/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';

export const useDocumentEventHandler = <K extends keyof DocumentEventMap>(
    eventType: K,
    listener: (this: Document, ev: DocumentEventMap[K]) => void
): void => {
    React.useEffect(() => {
        document.addEventListener(eventType, listener);

        return () => document.removeEventListener(eventType, listener);
    }, [listener]);
};
